var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardCircleLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#E0EEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5393 22.5102H28.1077L28.106 20.3218C28.1042 17.9378 26.198 15.9982 23.855 16C21.5119 16.0018 19.6057 17.9413 19.6075 20.3253L19.611 22.5138H19.4572C18.6517 22.5156 17.9983 23.1804 18 24V30.5156C18 31.3351 18.6552 32 19.4607 32L28.5428 31.9947C29.3483 31.9947 30.0017 31.3298 30 30.5102V23.9929C30 23.1733 29.3448 22.5102 28.5393 22.5102ZM21.1765 22.5138L21.173 20.3253C21.173 18.8196 22.3751 17.5947 23.855 17.5929C25.3349 17.5929 26.5387 18.8178 26.5387 20.3218L26.5422 22.5102L21.1765 22.5138Z",
    fill: "#E0EEF2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCircleLock);
export default __webpack_public_path__ + "static/media/card-circle-lock.9cc85375d0bebda01f54dbb8919538e9.svg";
export { ForwardRef as ReactComponent };